<footer class="fs-footer">
  <mat-toolbar color="accent">
    <img class="fs-footer-logo" src="/assets/images/logo-dark.png" alt="Teachers of Tomorrow">
    <div class="fs-footer-icons">
      <img (click)="openFacebook()" class="footer-social-icon" src="/assets/images/icon_facebook.svg">
      <img (click)="openTwitter()" class="footer-social-icon" src="/assets/images/icon_twitter.svg">
      <img (click)="openLinkedin()" class="footer-social-icon" src="/assets/images/icon_linkedin.svg">
      <img (click)="openYoutube()" class="footer-social-icon" src="/assets/images/icon_youtube.svg">
    </div>
    <span class="spacer"></span>
    <div class="fs-footer-copyright">COPYRIGHT © @if (now != undefined) {
      <span> {{ now | date:'y' }} </span>
    }TEACHERS OF TOMORROW, LLC. ALL RIGHTS RESERVED</div>
    <div style="position:absolute; color:lightgray; top:30px; right: 16px; font-size:x-small;" id="Build_Timestamp"></div>
  </mat-toolbar>
</footer>
